/**
 * Shuffle an array of items regardless the content
 *
 * @param array to be shuffled array
 * @see https://stackoverflow.com/a/2450976/4906586
 * @returns shuffled array
 */
export const shuffleArray = <T>(array: T[]): T[] => {
  const out = Array.from(array);

  for (let i = out.length - 1; i > 0; i--) {
    const r = Math.floor(Math.random() * (i + 1));
    const tmp = out[i];
    out[i] = out[r];
    out[r] = tmp;
  }

  return out;
};
